import { createSlice } from "@reduxjs/toolkit";

let dt = new Date();
dt.setMonth(dt.getMonth() - 1);

var initialState = {
  value: {
    startDate: dt,
    endDate: new Date(),
  },
};

export const ReportDateSlice = createSlice({
  name: "reportDate",
  initialState: initialState,
  reducers: {
    updateStartDate: (state, action) => {
      state.value.startDate = action.payload;
    },
    updateEndDate: (state, action) => {
      state.value.endDate = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateStartDate, updateEndDate, resetDate } =
  ReportDateSlice.actions;

export const selectReportDateValue = (state) => state.reportDate.value;

export default ReportDateSlice.reducer;
